/* eslint-disable @typescript-eslint/explicit-function-return-type */
import React from "react";
import { useTranslation } from "@emisgroup/acp-application-intl";
import ExtractEditView from "../../RightPanel/ExtractDetail/ExtractEditView";
import {
  Button,
  IListItem,
  FormSection,
  FormButton
} from "../../Common/UI/Index";
import { ButtonVariantType } from "../../Common/UI/Types";
import { IExtract } from "./redux/Types";
import "./Style.scss";

export interface IExtractAddViewProp {

  /**
   * Invalid title flag
   */
  newExtract: IExtract;

  /**
   * Flag to toggle Add/Edit view
   */
  isEdit?: boolean;

  /**
   * Closee callback 
   */
  onClose: () => void;

  /**
   * Data Values for year range dropdown
   */
  yearsDataValue: IListItem[];

  /**
   * On clicking create or update button to save extract
   */
  onSubmit: () => void;
}

type Props = IExtractAddViewProp;

/**
 * Responsible for rendering Extract Add view
 */
const ExtractAddView = (prop: Props): JSX.Element => {

  const {
    isEdit,
    onClose,
    yearsDataValue,
    newExtract,
    onSubmit
  } = prop;

  const { t: translate } = useTranslation();
  const isCreateBtnDisabled = (
    newExtract.title.value === "" ||
    newExtract.schema?.errorText !== "" ||
    newExtract.survey?.errorText !== ""
  );

  return (
    <div className="ebt-extract-add" data-testid="extract-create-container">
      <FormSection>
        <ExtractEditView
          isEdit={isEdit}
          newExtract={newExtract}
          yearsDataValue={yearsDataValue}
        />
        <FormButton className="ebt-extract-add__action-buttons">
          <Button
            variant={ButtonVariantType.FILLED}
            data-testid="extract-create"
            type="button"
            onClick={onSubmit}
            disabled={isCreateBtnDisabled}
          >
            {translate("Button.Create")}
          </Button>
          <Button
            borderless={true}
            data-testid="extract-cancel"
            type="button"
            onClick={onClose}
          >
            {translate("Button.Cancel")}
          </Button>
        </FormButton>
      </FormSection>
    </div>);
};

export default ExtractAddView;
